import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { UserPlusIcon } from "@phosphor-icons/react/dist/csr/UserPlus";
import { UsersThreeIcon } from "@phosphor-icons/react/dist/csr/UsersThree";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { StatTile } from "@volca/ui/components/ui/stat-tile";
import { cn } from "@volca/ui/lib/utils";
import { BUSINESS_SETTINGS_ROUTES } from "@/business-settings/constants";
import { useBusiness } from "@/core/business";

interface CounterLinkProps {
  to: string;
  label: string;
}

const CounterLink = ({ to, label }: CounterLinkProps) => (
  <Button
    variant="ghost"
    size="icon-sm"
    aria-label={label}
    render={<Link to={to} />}
    nativeButton={false}
  >
    <ArrowRightIcon />
  </Button>
);

interface AdvocateAndReferralCountersProps {
  advocates?: number;
  referrals?: number;
  isLoading?: boolean;
  isError?: boolean;
  className?: string;
}

export const AdvocateAndReferralCounters = ({
  advocates,
  referrals,
  isLoading,
  isError,
  className,
}: AdvocateAndReferralCountersProps) => {
  const { businessId } = useBusiness();

  if (!businessId) return null; // preloaded at app level

  const caption = isError ? "Couldn't load this number" : "All time";

  return (
    <div
      className={cn(
        "grid w-full grid-cols-2 gap-px bg-line xl:grid-cols-1",
        className,
      )}
    >
      <StatTile
        icon={UsersThreeIcon}
        label="Advocates"
        value={advocates ?? "–"}
        valueTone="brand"
        caption={caption}
        isLoading={isLoading}
        action={
          <CounterLink
            to={`/business-settings/${businessId}${BUSINESS_SETTINGS_ROUTES.advocates}`}
            label="View advocates"
          />
        }
      />
      <StatTile
        icon={UserPlusIcon}
        label="Referrals"
        value={referrals ?? "–"}
        valueTone="brand"
        caption={caption}
        isLoading={isLoading}
        action={
          <CounterLink
            to={`/business-settings/${businessId}${BUSINESS_SETTINGS_ROUTES.referralHistory}`}
            label="View referral history"
          />
        }
      />
    </div>
  );
};
